import { BaseLayout, type NavSection } from './BaseLayout';
import {
  Home, CalendarDays, BarChart3, Megaphone, Settings, Calendar, GraduationCap,
  User, Bell,
} from 'lucide-react';
import { useProfileBrandColor } from '../../theme/useProfileBrandColor';

const NAV_SECTIONS: NavSection[] = [
  {
    title: 'Estudos',
    items: [
      { to: '/aluno/dashboard', label: 'Início', icon: Home },
      { to: '/aluno/agenda', label: 'Agenda Escolar', icon: Calendar },
      { to: '/aluno/grade', label: 'Minha Grade', icon: CalendarDays },
      { to: '/aluno/frequencia', label: 'Frequência', icon: BarChart3 },
      { to: '/aluno/comunicados', label: 'Comunicados', icon: Megaphone },
      { to: '/aluno/ead', label: 'Video Aulas', icon: GraduationCap },
    ],
  },
  {
    title: 'Minha Conta',
    items: [
      { to: '/aluno/perfil', label: 'Meu Perfil', icon: User },
      { to: '/aluno/alertas', label: 'Meus Comunicados', icon: Megaphone },
    ],
  },
];

export function AlunoLayout() {
  const { brandColor, brandGradient } = useProfileBrandColor('ALUNO');
  return (
    <BaseLayout
      sections={NAV_SECTIONS}
      headerTitle="Meu Painel"
      brandColor={brandColor}
      brandGradient={brandGradient}
    />
  );
}
